import { connect } from 'react-redux'
import NewExpenseComponent from '../../components/expenses/newExpense.component'
import {
  saveExpense,
  closeExpenseSnackBar,
  saveExpenseUpdate,
  cancelExpenseUpdate,
  changeExpensePurchaseDate,
  disableExpenseBackBtn,
  editAndGoToInvoice,
  getUserCompanyUpdateInfo
} from '../../actions/index'

const mapStateToProps = (state) => {
  const { loader } = state
  const { showExpenseItemLoader } = loader

  return {
    user: state.oidc.user,
    showSpinner: state.expense.showSpinner,
    showSnackbar: state.expense.showSnackbar,
    showFailSnackbar: state.expense.showFailSnackbar,
    errorStatus: state.expense.errorStatus,
    isEdit: state.expense.isEdit,
    // showInvoices: formValues.decisionSelect,
    showExpenseItemLoader: showExpenseItemLoader,
    invoiceFormValues: state.invoice.invoiceFormValues
    //expense_row_exist: (getExpenseRowslength > 0) ? true : false,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    saveExpense: (formValues) => dispatch(saveExpense(formValues)),
    closeSnackbar: () => dispatch(closeExpenseSnackBar()),
    saveExpenseUpdate: (formValues) => dispatch(saveExpenseUpdate(formValues)),
    cancelExpenseUpdate: () => dispatch(cancelExpenseUpdate()),
    changeExpensePurchaseDate: (date) =>
      dispatch(changeExpensePurchaseDate(date)),
    disableExpenseBackBtn: () => dispatch(disableExpenseBackBtn()),
    editAndGoToInvoice: (formValues) =>
      dispatch(editAndGoToInvoice(formValues)),
    getUserCompanyUpdateInfo: () => dispatch(getUserCompanyUpdateInfo())
  }
}

const mergeProps = (stateProps, dispatchProps, ownProps) =>
  Object.assign({}, stateProps, dispatchProps, ownProps)

const newExpenseContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(NewExpenseComponent)

export default newExpenseContainer
